import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetDailyReportList(payload) {
    return Api(payload).post("/api/admin/getdailysalesreports", payload);
  },
  GetFilmWiseCollectionReport(payload) {
    return Api().post("/api/admin/getfilmwisecollectionreports", payload);
  },
  GetPerformanceReportList(payload) {
    return Api().post("/api/admin/getperformancereports", payload);
  },
  GetGcanReport(payload) {
    return Api().post("/api/admin/getgcamreports", payload);
  },
  GetAggregatorsReportList(payload) {
    return Api().post("/api/admin/getaggregatorreports", payload);
  },
  GetScreenWiseCollectionReport(payload) {
    return Api().post("/api/admin/getscreenwisecollectionsreports", payload);
  },
  GetDistributorReportList(payload) {
    return Api(payload).post(
      "/api/admin/v2/getdistributorwisecollectionsreports",
      payload
    );
  },
  GetDistributorReportListV4(payload) {
    return Api(payload).post(
      "/api/admin/v4/getdistributorwisecollectionsreports",
      payload
    );
  },
  GetDistributorDetailedSummaryReport(payload) {
    return Api().post("/api/admin/detailedDistributorReport", payload);
  },
  GetDistributorDetailedSummaryReportOman(payload) {
    return Api().post("/api/admin/detailedDistributorReportOman", payload);
  },
  GetDistributorDetailedSummaryReportBahrain(payload) {
    return Api_2().post("/api/admin/detailedDistributorReportBahrain", payload);
  },
  GetDistributorDetailedSummaryReportLebanon(payload) {
    return Api().post("/api/admin/detailedDistributorReportLebanon", payload);
  },
  // /api/admin/v2/getdistributorwisecollectionsreports
  GetDistributorMovie(payload) {
    return Api().post("/api/admin/getdistributorsmoviesbydistributor", payload);
  },
  GetDistributorMovieFormat(payload) {
    return Api(payload).post(
      "/api/admin/getdistributorsmovieswithformatbydistributor",
      payload
    );
  },
  GetSummaryReportList(payload) {
    return Api().post("/api/admin/getsummaries", payload);
  },

  GetPurchaseOrderList(payload) {
    return Api(payload).post("/api/admin/getpurchaseorder", payload);
  },
  GetInvoiceList(payload) {
    return Api().post("/api/admin/getinvoice", payload);
  },
  GetMunicipaltyReport(payload) {
    return Api(payload).post("/api/admin/getMunicipaltyReport", payload);
  },
  GetAdvanceBookingReport(payload) {
    return Api().post("/api/admin/getAdvanceBookingReport", payload);
  },

  GetMovieAnalytics(payload) {
    return Api().post("/api/admin/v2/getmovieanalytics", payload);
  },

  GetExpiryReports(payload) {
    return Api(payload).post("/api/admin/v2/getExpiryReport", payload);
  },
  GetAddOnsReport(payload) {
    return Api().post("/api/admin/v2/getAddOnsReport", payload);
  },
  GetCutomizationReport(payload) {
    return Api().post("/api/admin/v2/getCustomizationReport", payload);
  },
  GetOccupancyReport(payload) {
    return Api(payload).post("/api/admin/getOccupancyStatus", payload);
  },
  GetCinemaOverview(payload) {
    const query = createQueryString(payload);
    return Api_2().get(`/api/admin/mycinema_schedule_overview${query}`);
  },
  UpdateCinemaOverView(payload) {
    return Api().put(
      `/api/admin/mycinema_schedule_overview/${payload.md_id}`,
      payload
    );
  },
  GetGcamNewExcel(payload) {
    return Api(paylaod).post(`api/admin/v2/gcamReportV2`, payload);
  },
  GetDistributorCollectionReportV5(payload) {
    return Api().post(
      `/api/admin/v2/get-distributor-collection-report-v5`,
      payload
    );
  },
  GetDistributorCollectionReportV5Qfx(payload) {
    return Api(payload).post(
      `/api/admin/get-distributor-collection-report-v5-qfx`,
      payload
    );
  },
  GetCogsReportOptimized(payload) {
    return Api(payload).post(`/api/admin/getCogsReportOptimized`, payload);
  },

  GetFoodCostReport(payload) {
    return Api(payload).post(`/api/admin/getFoodCostReport`, payload);
  },
  GetEntryPointActivityReport(payload) {
    return Api(payload).post(`/api/reports/entryPointsActivityReport`, payload);
  },
  GetMovieOverallAnalysisMif(payload) {
    return Api(payload).post(`/api/reports/movieOverallAnalysisMif`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ReportsService.js